import { FleeterIcon } from "@features/copilot/components";
import {
	BarChartSquare02,
	ClipboardCheck,
	File02,
	FileShield02,
	MarkerPin01,
	SearchLg,
	User01,
	Users01,
	Wallet03,
} from "@untitledui/icons";
import type { NavItemType } from "@/components/application/app-navigation/config";
import { CarIcon } from "../icons/CarIcon";

export const navItems: NavItemType[] = [
	{ label: "Dashboard", href: "/home", icon: BarChartSquare02, items: [] },
	{
		label: "Telemetria",
		href: "/telemetria",
		icon: MarkerPin01,
		items: [
			{ label: "Rastreamento", href: "/tracking" },
			{ label: "Ranking", href: "/tracking/ranking" },
			{ label: "Eventos", href: "/tracking/events" },
			// { label: "Comunicação", href: "/tracking/communication" },
		],
	},
	{ label: "Veículos", href: "/vehicles", icon: CarIcon, items: [] },
	{
		label: "Checklists",
		href: "/formularios",
		icon: File02,
		items: [
			{
				label: "Histórico",
				href: "/inspections",
				icon: ClipboardCheck,
			},
			{ label: "Formulários", href: "/forms/list", icon: File02 },
			{ label: "Perguntas", href: "/questions/list", icon: SearchLg },
		],
	},
	{
		label: "Despesas",
		href: "/expenses",
		icon: Wallet03,
		items: [
			{
				label: "Visão Geral",
				href: "/expenses",
			},
			{
				label: "Relatórios",
				href: "/expenses/reports",
			},
			{
				label: "Histórico",
				href: "/expenses/history",
			},
		],
	},
	{
		label: "Infrações",
		href: "/infractions",
		icon: FileShield02,
		items: [
			{ label: "Gestão de Infrações" },
			{ label: "Cadastro de Infrações", href: "/infractions" },
		],
	},
	{ label: "Motoristas", href: "/drivers", icon: User01, items: [] },
	{ label: "Usuários", href: "/users", icon: Users01, items: [] },
	{
		label: "Copiloto",
		href: "/copilot",
		icon: FleeterIcon,
		items: [
			{
				label: "Resumo",
				href: "/copilot/summary",
			},
		],
	},
];
